import store from 'store';

const TOKEN_STORE_NAME = 'ITERIO_TOKEN';

export class Token {
  set(value) {
    store.set(TOKEN_STORE_NAME, value);
  }

  get() {
    return store.get(TOKEN_STORE_NAME);
  }
}



// WEBPACK FOOTER //
// ./src/models/Token.js